import ChartGroupingLevelSelectorFillingStrategy from './ChartGroupingLevelSelectorFillingStrategy'

function UsersGroupsLeaveTypesMonthsWeeksDaysGroupingLevelSelectorFillingStrategy() {}

UsersGroupsLeaveTypesMonthsWeeksDaysGroupingLevelSelectorFillingStrategy.prototype = new ChartGroupingLevelSelectorFillingStrategy();

UsersGroupsLeaveTypesMonthsWeeksDaysGroupingLevelSelectorFillingStrategy.prototype.fillGroupingLevelListSelector = function( listSelector )
{
    this.addUsersItem( listSelector );
    this.addUserGroupsItemIfNeeded( listSelector );
    this.addTimeZoneGroupsItemIfNeeded( listSelector );

    listSelector.addSeparator();

    this.addLeaveTypesItem( listSelector )
    listSelector.addSeparator();
    this.addDaysItem( listSelector );
    this.addWeeksItem( listSelector );
    this.addMonthsItem( listSelector );
};

export default UsersGroupsLeaveTypesMonthsWeeksDaysGroupingLevelSelectorFillingStrategy


// WEBPACK FOOTER //
// ./web/js/reports/charts/UsersGroupsLeaveTypesMonthsWeeksDaysGroupingLevelSelectorFillingStrategy.js